import type { PageLoad } from './$types'

// Empty load function - all data is handled through stores
export const load: PageLoad = (_event) => {
	return {}
}
